"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const index_1 = require("./index");
const text_1 = require("./text");
class CodeBlock extends index_1.TopLevelNode {
    constructor(language) {
        super();
        this.language = language;
        this.content = new index_1.ContentNode('codeBlock');
    }
    text(code) {
        this.content.add(text_1.plain(code));
        return this;
    }
    toJSON() {
        const codeBlock = this.content.toJSON();
        if (this.language) {
            codeBlock.attrs = {
                language: this.language
            };
        }
        return codeBlock;
    }
}
exports.CodeBlock = CodeBlock;
//# sourceMappingURL=code-block.js.map